function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { memo, useMemo } from "react";
import { Box, Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import { Subject, NotificationsActiveOutlined, PriorityHighOutlined } from "sprout-ui-icons";
import { formatToReact } from "sprout-lib/dist/parser";
import PostLabel from "./PostLabel";
import PostWhen from "./PostWhen";
const PostContentDescription = styled(Text)`
  display: inline;

  overflow-wrap: break-word;
  word-wrap: break-word;

  ${({ $completed  })=>$completed && css`
      text-decoration: line-through;
    `}
`;
const IconBox = styled(Box)`
  vertical-align: top;
`;
const PostContentLabels = styled("span")`
  display: none;

  ${media.up("medium", "pointer")} {
    display: inline;
  }
`;
const PostContent = (props)=>{
    const { description , note , labels , rootURL , completed , when , whenReminder , currentUserHasStarred ,  } = props;
    const hasLabels = labels.length > 0;
    const descriptionToRender = useMemo(()=>{
        return description ? formatToReact(description, "BASIC") : undefined;
    }, [
        description
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            currentUserHasStarred && /*#__PURE__*/ _jsx(IconBox, {
                ml: -1,
                color: "#38b7bf",
                as: PriorityHighOutlined
            }),
            when && /*#__PURE__*/ _jsx(PostWhen, {
                when: when
            }),
            descriptionToRender && /*#__PURE__*/ _jsx(PostContentDescription, {
                lineHeight: "24px",
                fontSize: "17px",
                mr: note || whenReminder || hasLabels ? 2 : undefined,
                color: description === "No description" ? "black.24" : "black.87",
                $completed: completed,
                children: descriptionToRender
            }),
            note && /*#__PURE__*/ _jsx(IconBox, {
                color: "blue.500",
                as: Subject,
                mr: hasLabels || whenReminder ? 2 : undefined
            }),
            whenReminder && /*#__PURE__*/ _jsx(IconBox, {
                color: "black.60",
                as: NotificationsActiveOutlined,
                mr: hasLabels ? 2 : undefined
            }),
            hasLabels && /*#__PURE__*/ _jsx(PostContentLabels, {
                children: labels.map((label)=>/*#__PURE__*/ _jsx(PostLabel, _objectSpread({}, label, {
                        to: `${rootURL}/label/${label.id}`
                    }), `${label.style}-${label.text}`))
            })
        ]
    });
};
export default /*#__PURE__*/ memo(PostContent);
